import React from 'react'

import './Hero.css'

const Hero = ({ title, children, modifiers }) => (
  <div className={'fmbm-hero ' + (modifiers ? modifiers.join(',') : '')}>
    <div className="fmbm-hero__container">
      {title && <div className="fmbm-hero__title">{title}</div>}
      {children}
      <div className="fmbm-hero__circle1" />
      <div className="fmbm-hero__circle2" />
      <div className="fmbm-hero__circle3" />
      <div className="fmbm-hero__circle4" />
    </div>
  </div>
)

export default Hero



// WEBPACK FOOTER //
// ./src/Components/Hero/Hero.js